module.exports = __webpack_public_path__ + "static/thumb_width_unicef_img2@2x-199932e59ce59f38c07958d605c826f7.jpg";